<template>
   <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height:89vh; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onChange="onChange"
            @onCreated="onCreated"
        />
    </div>
</template>

<script>

import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default Vue.extend({
  components:{ Editor,Toolbar },
  props:{
    content:{
      type:String,
      default:"",
    }
  },
  data(){
    return{
      editor:null,
      html:'',
      toolbarConfig:{},
      editorConfig:{ 
        placeholder:'请输入内容...',
        MENU_CONF:{
          // 配置上传图片
          uploadImage:{
            // 后端上传地址 必填
            server:"",
            fieldName:"file",
            meta:{},
            // 请求头
            headers:{token:localStorage.getItem("token")},
            timeout:5 * 100, //5s超过时间
            // 选择文件时的类型限制,默认为['image/*']如不想限制，则设置为[]
            allowedFileType:["image/*"],
            maxFileSize:30 * 1024 * 1024,  //1g  //设置大一点 不然图片过大会报错
            base64LimitSize:10000000 * 1024, //1g以下插入 base64
            // 自定义插入图片
            customInsert(res,insertFn){
              //res 即服务端返回的结果
              // 从res中找到url alt href , 然后插入图片
              insertFn(url,alt,href)
              
            }
          },
        }
      },
      mode:'default', //or 'simple'
    }
  },
  methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        setTimeout(() => {
            this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
        }, 1500)
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>